"use strict";

exports.__esModule = true;
exports.default = get;

var _isMap = _interopRequireDefault(require("./isMap"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function get(key, x) {
  return (0, _isMap.default)(x) ? x.get(key) : x[key];
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/get.js
// module id = 660
// module chunks = 0